import React from "react";

/**
 * ECLHeaderCell
 *
 * @export
 * @param {Object} props
 *      -ColumnInfo - {Object} - Object that holds column information, holds information like desired width of column
 *          - label - string - the content of the header
 *          - width - number -  width of the column
 *          - alignment - string - "left", "right", "center", controls text align
 *          - hide - bool - Whether or not to display the column header
 *          - filter - JSX - a jsx component containing the necessary functions to filter the table's underlying state
 *          - sort - JSX - a jsx component containing the necessary functions to sort the table's underlying state
 * @return {ReactComponent}
 */

export default function ECLHeaderCell(props) {
   let headerContentOffset = 0;
   if (props.columnInfo?.sort) {
      headerContentOffset += 40; //40px for sort button
   }

   if (props.columnInfo?.filter) {
      headerContentOffset += 40; //40px for filter button
   }

   return (
      <div
         role="columnheader"
         className="ecl-table-cell header-cell"
         style={{
            display: props.hide ? "none" : "flex",
            width: props.columnInfo?.width
               ? props.columnInfo.width + "px"
               : Math.floor((1 / props.columnSettings.length) * 100) + "%",
            minWidth: props.columnInfo?.width
               ? props.columnInfo.width + "px"
               : "150px",
         }}
      >
         {props.columnInfo?.additionalRows ? ( //If we need extra headers, we'll stack them in the header cell
            <div className="header-stacker">
               <p
                  title={props.columnInfo?.label}
                  className="string-cell cell-trunc"
                  style={{
                     width: "100%",
                     fontWeight: "bold",
                  }}
               >
                  {props.columnInfo?.label}
               </p>
               {props.columnInfo?.additionalRows.map((r, i) => {
                  if (r) {
                     return (
                        <p
                           title={r}
                           key={r + i}
                           className="string-cell cell-trunc"
                           style={{
                              width: "100%",
                              fontWeight: "bold",
                           }}
                        >
                           {r}
                        </p>
                     );
                  }
                  return null;
               })}
            </div>
         ) : (
            <p
               title={props.columnInfo?.label}
               className="string-cell cell-trunc"
               style={{
                  width: "calc(100% - " + headerContentOffset + " px)", //40px for each button in element (Adjust to 80 px once sort UI is defined) see ECLtable.css for sizing rules of buttons within the header-cell class
                  fontWeight: "bold",
               }}
            >
               {props.columnInfo?.label}
            </p>
         )}
         {props.columnInfo?.sort && props.columnInfo.sort}
         {props.columnInfo?.filter && props.columnInfo.filter}
      </div>
   );
}
